import { useSelector } from "react-redux";
import PreviewComponent from "../../../viewer/tile/PreviewComponent.tsx";
import { selectTileFields } from "../../../../store/selectors/fieldsStateSelectors";
import useTileDataBuilder from "../hooks/useTileDataBuilder";

const EditPreviewComponent = () => {
  const fieldsAreaValues = useSelector(selectTileFields);

  const data = useTileDataBuilder();

  return <PreviewComponent data={data} fields={fieldsAreaValues} />;
};

export default EditPreviewComponent;
